export class AddressModel {
  AddressLine1 = '';
  AddressLine2 = '';
  AddressLine3 = '';
  PostTown = '';
  County = '';
  PostCode = '';
  Country = '';
}
